export default __webpack_public_path__ + "static/media/leadership.175ec08d.png";